import {
  saleResidentialObjectTypes,
  rentResidentialObjectTypes,
  dailyRentResidentialObjectTypes,
} from '../../constants/objectTypes';

export const getAllResidentialObjectTypesKeys = () => {
  const combinedEnums = [
    ...saleResidentialObjectTypes,
    ...rentResidentialObjectTypes,
    ...dailyRentResidentialObjectTypes,
  ];

  const uniqueSet = combinedEnums.reduce((memo: TBooleanObject, objectType) => {
    memo[objectType.key] = true;

    return memo;
  }, {});

  return Object.keys(uniqueSet);
};
